import {
  BranchConfigsResponse,
  CustomMergeCheck,
  CustomMergeChecksConfigApi,
  CustomMergeChecksConfigurationResponse,
  CustomMergeChecksConfigureApi,
} from 'src/types/custom-merge-checks';
import { createHttpRequest } from 'src/utils/http-request';

export const customMergeChecksConfigApi = (
  url: string
): CustomMergeChecksConfigApi => {
  return {
    getBranchConfigs: () =>
      createHttpRequest<BranchConfigsResponse>('GET')(`${url}/branch-config`),
    getCustomMergeChecks: () =>
      createHttpRequest<CustomMergeChecksConfigurationResponse>('GET')(
        `${url}/enabled-checks`
      ),
  };
};

export const createCustomMergeChecksConfigureApi = (
  url: string
): CustomMergeChecksConfigureApi => {
  return {
    addCheck: (extensionId, branch, state) =>
      createHttpRequest<CustomMergeCheck>('POST')(`${url}/enabled-checks`, {
        extensionId,
        branch,
        state,
      }),
    editCheck: (uuid, state) =>
      createHttpRequest<CustomMergeCheck>('PUT')(
        `${url}/enabled-checks/${uuid}`,
        {
          state,
        }
      ),
    deleteCheck: uuid =>
      createHttpRequest<{}>('DELETE')(`${url}/enabled-checks/${uuid}`, {}),
  };
};
